var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('CPopup',{attrs:{"title":"用户协议"},model:{value:(_vm.is_show),callback:function ($$v) {_vm.is_show=$$v},expression:"is_show"}},[_c('div',{staticStyle:{"max-height":"50vh","overflow-y":"auto"},domProps:{"innerHTML":_vm._s(_vm.user_arge)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }